export default "__VITE_ASSET__BJBYVJmx__"